import { useEffect } from "react";
import i18n from "../../i18n";

/** Keeps `document.documentElement.lang` in sync with the active i18n language. */
export default function I18nLangSync() {
    useEffect(() => {
        const apply = () => {
            document.documentElement.lang = i18n.language || "en";
        };
        apply();
        i18n.on("languageChanged", apply);
        return () => {
            i18n.off("languageChanged", apply);
        };
    }, []);
    return null;
}
